import { http } from '$lib/http';
import { API_URL } from '$lib/helpers';
import { ICreateMemberModel, ISignUpModelArgs } from '$models';

const BASE_URL = `${API_URL}/scom/api`;
export const signUpUserToAgillic = async (signUpModel: ISignUpModelArgs): Promise<boolean> => {
    const response = await http(`${BASE_URL}/agillic/signup`, {
        body: JSON.stringify(signUpModel),
        method: 'POST',
    });

    return response.ok;
};

export const signUpUserToBC365 = async (signUpModel: ICreateMemberModel): Promise<boolean> => {
    const response = await http(`${BASE_URL}/loyalty/signup`, {
        body: JSON.stringify(signUpModel),
        method: 'POST',
    });

    return response.ok;
};
